const PACKAGE = 'package';
const PALLET = 'pallet';

export { PACKAGE, PALLET };
